<template>
      <div class="accountTerminologyCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'accountTerminology', params: {} }">
          Account Terminology
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'accountTerminologyCreate', params: {} }">
            Create Account Terminology
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Account Terminology</v-card-title>
          <v-card-text>
            <accountTerminology-form></accountTerminology-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import AccountTerminologyForm from './AccountTerminologyForm.vue';

    export default {
      name: 'accountTerminology',
      components: {
        AccountTerminologyForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    